import DataTable from "react-data-table-component";
import { useEffect, useState } from "react";
import {
  exportableFieldsReportType,
  exportableFieldsFamily,
  userData,
  selectedOptic,
  exportDataStore,
} from "../js/utils";
import {
  storeSupplierSummaryTable,
  storeBrandSummaryTable,
} from "../js/tableColumns";
import { download, post } from "../js/post";
import moment from "moment";
import "moment/locale/es";
import { TabSelector } from "./TabSelector";
import InputIconSearch from "./InputIconSearch";
import PopupMessage from "./PopupMessage";
import LoadingScreen from "./LoadingScreen";
import { DashboardStoreOptionSelector } from "./DashboardStoreOptionSelector";
import { DashboardStorePanelFilterSection } from "./DashboardStorePanelFilterSection";
import { DashboardStorePanelFilterSectionReportType } from "./DashboardStorePanelFilterSectionReportType";
import { DashboardStorePanelFilterSectionExportableFields } from "./DashboardStorePanelFilterSectionExportableFields";
import { DashboardStorePanelFilterSectionExportableFieldsTypology } from "./DashboardStorePanelFilterSectionExportableFieldsTypology";
import { DashboardStorePanelFilterSectionOutputSetting } from "./DashboardStorePanelFilterSectionOutputSetting";
import { DashboardStorePanelFilterSectionExport } from "./DashboardStorePanelFilterSectionExport";
import { DashboardStoreStatsPanel } from "./DashboardStoreStatsPanel";
import { DashboardStoreChartsPanel } from "./DashboardStoreCharts";

export function DashboardStorePanel({
  openCashPopup,
  createPopupQuestion,
  removePopupQuestion,
}) {
  moment.locale("es");
  const [supplierRankingList, setSupplierRankingList] = useState([]);
  const [supplierRankingListFiltered, setSupplierRankingListFiltered] =
    useState([]);
  const [brandRankingList, setBrandRankingList] = useState([]);
  const [brandRankingListFiltered, setBrandRankingListFiltered] = useState([]);
  const [searchYear, setSearchYear] = useState(moment());
  const [selectedSupplier, setSelectedSupplier] = useState({
    id: "",
    name: "",
  });
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedPanelView, setSelectedPanelView] = useState("Listados");
  const [supplierSearch, setSupplierSearch] = useState("");
  const [brandSearch, setBrandSearch] = useState("");
  const [loadingBrands, setLoadingBrands] = useState(false);
  const [selectedOption, setSelectedOption] = useState({
    inventarios: true,
    compras: false,
    ventas: false,
    traspasos: false,
    ajustes: false,
    tipologias: false,
  });
  const [sendingEmail, setSendingEmail] = useState(false);
  const [sendingEmailMessage, setSendingEmailMessage] = useState("");
  const [sendingEmailMessageDef, setSendingEmailMessageDef] = useState("");

  const [exportData, setExportData] = useState(exportDataStore);

  // console.log("exportData: ", exportData);

  const updatedColumnsSup = storeSupplierSummaryTable.map((col) => {
    if (col.name === "") {
      return {
        ...col,
        cell: (row) =>
          row.idProveedor ? (
            <button
              onClick={(e) => {
                if (selectedSupplier.id !== row.idProveedor) {
                  setSelectedSupplier({
                    id: row.idProveedor,
                    name: row.proveedor,
                  });
                }
                e.stopPropagation();
                openCashPopup(
                  row.idProveedor,
                  "",
                  true,
                  moment(
                    `${moment(searchYear).format("YYYY")}-01-01`,
                    "YYYY-MM-DD",
                  ).format("YYYY-MM-DD"),
                  moment(
                    `${moment(searchYear).format("YYYY")}-12-31`,
                    "YYYY-MM-DD",
                  ).format("YYYY-MM-DD"),
                  1,
                  row.proveedor,
                  "",
                );
              }}
              tabIndex={-1}
            >
              Ver más
            </button>
          ) : (
            ""
          ),
      };
    }

    return col;
  });

  const updatedColumnsBra = storeBrandSummaryTable.map((col) => {
    if (col.name === "") {
      return {
        ...col,
        cell: (row) =>
          row.marca ? (
            <button
              onClick={(e) => {
                setSelectedBrand(row.marca);
                e.stopPropagation();
                openCashPopup(
                  selectedSupplier.id,
                  "",
                  true,
                  moment(
                    `${moment(searchYear).format("YYYY")}-01-01`,
                    "YYYY-MM-DD",
                  ).format("YYYY-MM-DD"),
                  moment(
                    `${moment(searchYear).format("YYYY")}-12-31`,
                    "YYYY-MM-DD",
                  ).format("YYYY-MM-DD"),
                  1,
                  selectedSupplier.name,
                  row.marca,
                );
              }}
              tabIndex={-1}
            >
              Ver más
            </button>
          ) : (
            ""
          ),
      };
    }

    return col;
  });

  const conditionalRowStyleSupplier = [
    {
      when: (row) => row.idProveedor === selectedSupplier.id,
      classNames: ["selected-optic-row"],
    },
  ];

  const conditionalRowStyleBrand = [
    {
      when: (row) => row.marca === selectedBrand,
      classNames: ["selected-optic-row"],
    },
  ];

  async function getSuppliersRanking() {
    const response = await post(
      "support-extra/dashboard/ObtenerRankingProveedoresDashboard.php",
      {
        token: userData.token,
        ano: moment(searchYear).year(),
      },
    );
    setSupplierRankingList(response);
    setSupplierRankingListFiltered(response);
    if (response.length > 0) {
      setSelectedSupplier({
        id: response[0].idProveedor,
        name: response[0].proveedor,
      });
    } else {
      setSelectedSupplier({ id: "", name: "" });
    }
  }

  async function getBrandsRanking() {
    try {
      setLoadingBrands(true);
      const response = await post(
        "support-extra/dashboard/ObtenerRankingMarcasDashboard.php",
        {
          token: userData.token,
          ano: moment(searchYear).year(),
          idProveedor: selectedSupplier.id,
        },
      );

      setBrandRankingList(response);
      setBrandRankingListFiltered(response);
      if (response.length > 0) {
        setSelectedBrand(response[0].marca);
      } else {
        setSelectedBrand("");
      }
    } catch (error) {
      //
    } finally {
      setLoadingBrands(false);
    }
  }

  function getReportTypeId() {
    const typeMap = {
      inventarios: 0,
      compras: 1,
      ventas: 2,
      traspasos: 3,
      ajustes: 4,
      tipologias: 5,
    };

    const selectedKey = Object.keys(typeMap).find((key) => selectedOption[key]);

    return selectedKey !== undefined ? typeMap[selectedKey] : null;
  }

  async function exportFile(email) {
    const missingOrigin =
      exportData.tipoCategoria === 3 &&
      exportData.tipoSalida?.opticasOrigen?.length === 0;
    const missingDestination =
      exportData.tipoCategoria === 3 &&
      exportData.tipoSalida?.opticasDestino?.length === 0;

    if (exportData.familia === "" || exportData.opticas.length === 0) {
      createPopupQuestion(
        "Debe seleccionar una familia y al menos una óptica en filtros comunes.",
        () => {
          removePopupQuestion();
          return;
        },
        null,
        "Entendido",
      );
    } else if (missingOrigin || missingDestination) {
      createPopupQuestion(
        "Debe seleccionar ópticas origen y destino en el tipo de salida.",
        () => {
          removePopupQuestion();
        },
        null,
        "Entendido",
      );
    } else {
      const exportDatAux = {
        token: userData.token,
        ...exportData,
        email: !email ? "" : exportData.email,
        idOpticaEmail: !email ? "" : selectedOptic.id,
      };
      if (!email) {
        setSendingEmailMessageDef(
          <LoadingScreen message="Generando archivo..."></LoadingScreen>,
        );
        setSendingEmail(true);
        const response = await download(
          "support-extra/dashboard/ExportacionAlmacen.php",
          exportDatAux,
          // Los PDF se previsualizan en el navegador; Excel/CSV se descargan
          { abrirEnPestana: exportData.tipoFichero === 0 },
        );
        // console.log("EXPORTANDO: ", exportDatAux, response);
        if (response.error !== "") {
          setSendingEmailMessage(response.error);
        } else setSendingEmail(false);
      } else {
        setSendingEmailMessageDef(
          <LoadingScreen message="Enviando archivo..."></LoadingScreen>,
        );
        setSendingEmail(true);
        const response = await post(
          "support-extra/dashboard/ExportacionAlmacen.php",
          exportDatAux,
        );
        if (response.error !== "") {
          setSendingEmailMessage(response.error);
        } else {
          setSendingEmailMessage("El email se ha enviado correctamente.");
        }
      }
    }
  }

  useEffect(() => {
    getSuppliersRanking();
  }, [searchYear]);

  useEffect(() => {
    getBrandsRanking();
  }, [selectedSupplier]);

  useEffect(() => {
    if (supplierSearch !== "") {
      setSupplierRankingListFiltered(
        supplierRankingList.filter((e) => e.proveedor.includes(supplierSearch)),
      );
    } else setSupplierRankingListFiltered(supplierRankingList);
  }, [supplierSearch]);

  useEffect(() => {
    if (brandSearch !== "") {
      setBrandRankingListFiltered(
        brandRankingList.filter((e) => e.marca.includes(brandSearch)),
      );
    } else setBrandRankingListFiltered(brandRankingList);
  }, [brandSearch]);

  useEffect(() => {
    if (!selectedOption) return;

    const mapping = {
      inventarios: 0,
      compras: 1,
      ventas: 2,
      traspasos: 3,
      ajustes: 4,
      tipologias: 5,
    };

    const tipoCategoria = Object.keys(mapping).find(
      (key) => selectedOption[key] === true,
    );

    if (tipoCategoria !== undefined) {
      setExportData((prev) => ({
        ...prev,
        tipoCategoria: mapping[tipoCategoria],
      }));
    }
  }, [selectedOption]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 20,
      }}
    >
      <div className="patient-search-content dashboard-bg">
        <div className="opt-table-title">Análisis de almacén</div>
        <div className="dashboard-content-data">
          {sendingEmail && (
            <PopupMessage
              text={
                sendingEmailMessage === ""
                  ? sendingEmailMessageDef
                  : sendingEmailMessage
              }
              textAccept={sendingEmailMessage === "" ? null : "Entendido"}
              onClickAccept={
                sendingEmailMessage === ""
                  ? null
                  : () => {
                      setSendingEmailMessage("");
                      setSendingEmailMessageDef("");
                      setSendingEmail(false);
                    }
              }
            ></PopupMessage>
          )}
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              gap: 10,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 40,
                width: "100%",
              }}
            >
              <div
                className="dashboard-summary-table thin-rounded-border dashboard-analysis-box"
                style={{ width: "50%" }}
              >
                <div className="opt-table-title opt-table-title-dash-stats">
                  Ranking de proveedores
                  <div className="data-field">
                    <button
                      className="incdec-btn"
                      tabIndex={-1}
                      onClick={() => {
                        setSearchYear((prev) =>
                          moment(prev).subtract(1, "year"),
                        );
                      }}
                    >
                      {"<"}
                    </button>
                    <span style={{ width: "60px", textAlign: "center" }}>
                      {moment(searchYear).year()}
                    </span>
                    <button
                      className="incdec-btn"
                      tabIndex={-1}
                      onClick={() => {
                        setSearchYear((prev) => moment(prev).add(1, "year"));
                      }}
                    >
                      {">"}
                    </button>
                  </div>
                </div>
                <div className="data-field">
                  <InputIconSearch
                    size={3}
                    tabIndex={8}
                    placeholder={"Proveedor"}
                    input={supplierSearch}
                    onChange={async (e) => {
                      setSupplierSearch(e);
                    }}
                    onClear={async () => {
                      setSupplierSearch("");
                    }}
                  ></InputIconSearch>
                </div>
                <DataTable
                  columns={updatedColumnsSup}
                  data={supplierRankingListFiltered}
                  className="custom-datatable dashboard-custom-table"
                  noDataComponent="No hay proveedores disponibles."
                  conditionalRowStyles={conditionalRowStyleSupplier}
                  onRowClicked={(row) => {
                    if (row.idProveedor !== selectedSupplier.id) {
                      setSelectedSupplier({
                        id: row.idProveedor,
                        name: row.proveedor,
                      });
                      setSelectedBrand("");
                    }
                  }}
                />
                {supplierRankingListFiltered.length > 0 && (
                  <DataTable
                    columns={updatedColumnsSup}
                    data={[
                      {
                        idProveedor: "",
                        proveedor: "",
                        volumenCompras: supplierRankingListFiltered.reduce(
                          (acc, e) => acc + e.volumenCompras,
                          0,
                        ),
                        volumenVentas: supplierRankingListFiltered.reduce(
                          (acc, e) => acc + e.volumenVentas,
                          0,
                        ),
                      },
                    ]}
                    className="custom-datatable summary-row no-header-datatable"
                  />
                )}
              </div>
              <div
                className="dashboard-summary-table thin-rounded-border dashboard-analysis-box"
                style={{ width: "50%" }}
              >
                <div className="opt-table-title opt-table-title-dash-stats">
                  Ranking de marcas del proveedor
                </div>
                {loadingBrands && (
                  <LoadingScreen message="Cargando marcas..."></LoadingScreen>
                )}
                {!loadingBrands && (
                  <>
                    <div className="data-field">
                      <InputIconSearch
                        size={3}
                        tabIndex={9}
                        placeholder={"Marca"}
                        input={brandSearch}
                        onChange={async (e) => {
                          setBrandSearch(e);
                        }}
                        onClear={async () => {
                          setBrandSearch("");
                        }}
                      ></InputIconSearch>
                    </div>
                    <DataTable
                      columns={updatedColumnsBra}
                      data={brandRankingListFiltered}
                      className="custom-datatable dashboard-custom-table"
                      noDataComponent="No hay marcas disponibles."
                      conditionalRowStyles={conditionalRowStyleBrand}
                      onRowClicked={(row) => {
                        if (row.marca !== selectedSupplier.marca) {
                          setSelectedBrand(row.marca);
                        }
                      }}
                    />
                    {brandRankingListFiltered.length > 0 && (
                      <DataTable
                        columns={updatedColumnsBra}
                        data={[
                          {
                            marca: "",
                            volumenCompras: brandRankingListFiltered.reduce(
                              (acc, e) => acc + e.volumenCompras,
                              0,
                            ),
                            volumenVentas: brandRankingListFiltered.reduce(
                              (acc, e) => acc + e.volumenVentas,
                              0,
                            ),
                          },
                        ]}
                        className="custom-datatable summary-row no-header-datatable"
                      />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="patient-search-content dashboard-bg">
        <div className="opt-table-title">
          Listados y estadísticas de almacén
        </div>
        <div className="dashboard-content-data">
          <div className="dashboard-content-panel">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <TabSelector
                options={["Listados", "Estadísticas", "Gráficos"]}
                style={{ borderBottom: "none" }}
                selected={selectedPanelView}
                onChange={(e) => {
                  setSelectedPanelView(e);
                }}
              />
            </div>
            <div className="thin-section-rounded-border">
              {/* Ambas pestañas permanecen montadas para conservar su estado */}
              <div
                style={{
                  display: selectedPanelView === "Listados" ? "flex" : "none",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 20,
                  width: "100%",
                }}
              >
                <DashboardStoreOptionSelector
                  onSelect={(e) => setSelectedOption(e)}
                />
                <DashboardStorePanelFilterSection
                  onChange={(e) =>
                    setExportData((prev) => ({
                      ...prev,
                      familia: e.familia,
                      opticas: e.opticas,
                      proveedores: e.proveedores,
                      marcas: e.marcas,
                    }))
                  }
                />
                <DashboardStorePanelFilterSectionReportType
                  reportType={selectedOption}
                  onChange={(e) =>
                    setExportData((prev) => ({
                      ...prev,
                      filtros: e,
                    }))
                  }
                />
                <DashboardStorePanelFilterSectionExportableFields
                  exportableFields={exportableFieldsReportType}
                  type={0}
                  typeId={getReportTypeId()}
                  onChange={(e) => {
                    setExportData((prev) => ({
                      ...prev,
                      camposInforme: e,
                    }));
                  }}
                />
                {!selectedOption.tipologias && (
                  <DashboardStorePanelFilterSectionExportableFields
                    exportableFields={exportableFieldsFamily}
                    type={1}
                    typeId={exportData.familia}
                    onChange={(e) => {
                      setExportData((prev) => ({
                        ...prev,
                        camposFamilia: e,
                      }));
                    }}
                  />
                )}
                {selectedOption.tipologias && (
                  <DashboardStorePanelFilterSectionExportableFieldsTypology
                    typeId={exportData.familia}
                    onChange={(e) => {
                      setExportData((prev) => ({
                        ...prev,
                        camposFamiliaTipologia: e,
                      }));
                    }}
                  />
                )}
                <DashboardStorePanelFilterSectionOutputSetting
                  typeId={getReportTypeId()}
                  onChange={(e) =>
                    setExportData((prev) => ({
                      ...prev,
                      tipoSalida: e,
                    }))
                  }
                />
                <DashboardStorePanelFilterSectionExport
                  createPopupQuestion={createPopupQuestion}
                  removePopupQuestion={removePopupQuestion}
                  onExport={exportFile}
                  onChange={(fileType, email) => {
                    setExportData((prev) => ({
                      ...prev,
                      tipoFichero: fileType,
                      email: email,
                    }));
                  }}
                />
              </div>
              <div
                style={{
                  display:
                    selectedPanelView === "Estadísticas" ? "block" : "none",
                }}
              >
                <DashboardStoreStatsPanel />
              </div>
              <div
                style={{
                  display: selectedPanelView === "Gráficos" ? "block" : "none",
                }}
              >
                <DashboardStoreChartsPanel />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
